import React from "react"
import ReactDOM from "react-dom"
import { Amplify } from "aws-amplify"
import { BrowserRouter } from "react-router-dom"

import awsExports from "./aws-exports"
import App from "./App"
import reportWebVitals from "./reportWebVitals"

import "./index.css"

Amplify.configure(awsExports)
const rootElement = document.getElementById("root")

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter basename="/">
      <App />
    </BrowserRouter>
  </React.StrictMode>,
  rootElement
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
